export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtres"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magasin"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Appliquer"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout effacer"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner le statut"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner le magasin"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrer le numéro de facture"])}
}